import { render, staticRenderFns } from "./dashboard_page.vue?vue&type=template&id=3cb987a6&scoped=true&"
import script from "./dashboard_page.vue?vue&type=script&lang=js&"
export * from "./dashboard_page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_page.vue?vue&type=style&index=0&id=3cb987a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb987a6",
  null
  
)

export default component.exports